import React from 'react';
import { Link } from 'react-router-dom';

import Video from '../../assets/SlideshowESG/Video.mp4';

const EsgComponent = () => {
    return (
        <div className='flex flex-col  overflow-x-hidden'>
            <div className='w-full md:h-[800px] h-[400px] relative flex justify-center item-center'>
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='w-full h-full object-cover'
                    preload="auto"
                >
                    <source src={Video} type="video/mp4" />
                </video>
            </div>
            <div className='w-full grid xl:grid-cols-2 lg:grid-cols-3 bg-black text-white pb-20'>
                <div className='col-span-1 flex justify-end md:p-10 p-5 md:text-4xl text-3xl font-bold'>
                    ESG
                </div>
                <div className='xl:col-span-1 col-span-2 flex flex-col items-start gap-y-5 md:p-10 p-5 xl:text-4xl md:text-3xl text-2xl xl:leading-[50px]'>
                    The adoption of strong ESG practices is a fundamental part of our business. In addition to promoting a culture based on key Health, Safety, Security and Environment (HSSE) policies, in our farms we are committed to a thorough range of actions such as improving carbon sequestration, reducing greenhouse emissions, improving the local ecosystem and making the most efficient use of resources.
                    <Link to="/esg/details" className='xl:text-4xl text-3xl text-lgreen'>Learn more</Link>
                </div>
            </div>
        </div>
    )
}

export default EsgComponent